import { uniqBy } from 'lodash'

import { AdaptedComponent } from '../inverted-dependencies/components'

export const getUniqueDisableableComponents = (
  components: AdaptedComponent[],
) => uniqBy(
  components.filter(({ enabled }) => enabled),
  ({ id }) => id,
)

export const findComponentWithAction = (
  components: AdaptedComponent[],
  targetAction: string,
) => components.find(component => {
  const action = component.connectionConfig?.events?.onClick?.action
  return action === targetAction
})